// extracted by mini-css-extract-plugin
export var orderSummary = "_tx-0";
export var showMoreLessButton = "_tx-1";